<template>
    <mds-layout-grid :class="elClasses">
        <mds-row>
            <mds-col :cols="12">
                <div>
                    <mds-section
                        :class="namespaceClass('__summary-header')"
                        :title="this.getUILabel('SUMMARY_HEADING')"
                        :border="isInvestmentFlow ? 'none' : 'secondary'"
                        :borderPosition="isInvestmentFlow ? 'top' : 'bottom'"
                        :size="4"
                    >
                        <template v-slot:mds-section-actions>
                            <mds-button-container>
                                <mds-button
                                    v-if="$store.getters['config/isScenarioAnalysisEnabled']"
                                    variation="secondary"
                                    type="button"
                                    @click="showScenarioModal = true"
                                    >{{ getUILabel("SUMMARY_SCENARIO_ANALYSIS") }}</mds-button
                                >
                                <mds-button v-if="false" variation="secondary" type="button">{{ getUILabel("SUMMARY_BUILD_REPORT") }}</mds-button>
                            </mds-button-container>
                        </template>
                    </mds-section>
                    <scenario-modal
                        v-if="showScenarioModal"
                        :mwc-id="getMwcIdForChild('ScenarioModal')"
                        :propShow="showScenarioModal"
                        @scenario-event="handleScenarioModal"
                    ></scenario-modal>
                    <mds-row>
                        <mds-col
                            :class="namespaceClass('__portfolio-action-wrapper')"
                            v-for="(item, index) in portfolioHeaderList"
                            :cols="portfolioHeaderList.length === 1 ? 12 : 6"
                            :key="item.portfolioData.id"
                        >
                            <portfolio-actions
                                :mwc-id="getMwcIdForChild('portfolioActions')"
                                :portfolioIndex="index"
                                :benchmarkData="item.benchmarkData"
                            ></portfolio-actions>
                        </mds-col>
                    </mds-row>
                </div>
            </mds-col>
            <mds-col :cols="12">
                <mds-row>
                    <mds-col :cols="12">
                        <div :class="namespaceClass('-chart-wrapper')">
                            <mds-loader
                                v-if="this.chartLoading || this.hypoInputLoading || !this.$store.state.chart.chartData"
                                :class="namespaceClass('-chart-loading')"
                            ></mds-loader>
                            <investments-charts
                                v-if="!this.chartLoading && this.$store.state.chart.chartData"
                                mwc-id="hypo-investments-charts"
                                :class="namespaceClass('-charts')"
                            ></investments-charts>
                        </div>
                    </mds-col>
                </mds-row>
            </mds-col>
        </mds-row>
        <mds-alert
            v-show="showAlert"
            :class="namespaceClass('alert')"
            variation="warning"
            size="medium"
            :persistent="false"
            :title="alertMessage"
            :list="invalidHoldings"
            @mds-alert-dismissed="showAlert = false"
            role="alertdialog"
        >
        </mds-alert>
        <mds-alert
            v-show="showPortfolioError"
            :class="namespaceClass('error')"
            variation="warning"
            size="medium"
            :persistent="false"
            :title="portfolioErrorInfo"
            @mds-alert-dismissed="showPortfolioError = false"
            role="alertdialog"
        >
        </mds-alert>
    </mds-layout-grid>
</template>

<script>
import HypoVueBaseMixin from "hypo-vue-base-mixin";
import "hypo-growth-chart/src/index";
import "hypo-return-bar-chart/src/index";
import InvestmentsCharts from "./InvestmentsCharts.vue";
import * as types from "@/store/mutation-types.js";
import MwcSharedMixin from "@/mixins/MwcSharedMixin";
import PortfolioActions from "../NewWorkflow/PortfolioActions";
import MdsAlert from "@mds/alert";
import { MdsLayoutGrid, MdsRow, MdsCol } from "@mds/layout-grid";
import MdsLoader from "@mds/loader";
import MdsSection from "@mds/section";
import { MdsButton, MdsButtonContainer } from "@mds/button";
import ScenarioModal from "../NewWorkflow/ScenarioModal.vue";

export default {
    name: "home",
    mixins: [HypoVueBaseMixin, MwcSharedMixin],
    components: {
        MdsAlert,
        MdsLayoutGrid,
        MdsLoader,
        MdsRow,
        MdsCol,
        MdsSection,
        MdsButton,
        MdsButtonContainer,
        PortfolioActions,
        InvestmentsCharts,
        ScenarioModal
    },
    data() {
        return {
            defaultConfig: {
                labels: this.$store.state.labels.labels
            },
            chartLoading: false,
            hypoInputLoading: false,
            showAlert: false,
            invalidHoldings: [],
            alertMessage: "",
            showPortfolioError: false,
            portfolioErrorInfo: "",
            showScenarioModal: false
        };
    },
    computed: {
        isInvestmentFlow() {
            return parseInt(this.$store.getters["hypo/getType"]) === 2;
        },
        hasPortfolio() {
            return this.$store.getters["investments/hasPortfolio"];
        },
        elClasses() {
            return {
                [`${this.namespaceClass()}`]: true,
                [`${this.namespaceClass("--single")}`]: this.portfolioList.length === 1
            };
        },
        portfolioHeaderList() {
            return this.portfolioList.map((portfolio, index) => {
                const portfolioData = {
                    id: portfolio.id,
                    name: portfolio.name,
                    title: `${this.getUILabel("common_portfolio")} ${index + 1}`
                };
                const portfolioHeaderData = {
                    portfolioData: portfolioData,
                    menuData: this.portfolioMenuData
                };

                if (portfolio.benchmark && portfolio.benchmark.includeBenchmark) {
                    const chartBenchmarkData = this.getBenchmarkDataByPortfilio(portfolio, this.growthData);
                    const hasIndex = this.$store.getters["hypo/getType"]?.toString() === "1";
                    portfolioHeaderData.benchmarkData = {
                        title: `${this.getUILabel("common_benchmark")} ${hasIndex ? index + 1 : ""}`,
                        ...chartBenchmarkData
                    };
                }
                return portfolioHeaderData;
            });
        },
        growthData() {
            const chartData = this.$store.state.chart.chartData;
            if (chartData && chartData.growth) {
                return chartData.growth;
            }
            return [];
        },
        portfolioNumberLimit() {
            return this.$store.getters["config/portfolioNumberLimit"];
        },
        portfolioMenuData() {
            return [
                {
                    label: this.getUILabel("home_card_menu_delete"),
                    value: "delete",
                    disabled: !this.$store.state.chart?.chartData
                },
                {
                    label: this.getUILabel("home_card_menu_duplicate"),
                    value: "duplicate",
                    disabled: this.portfolioList.length === this.portfolioNumberLimit || !this.$store.state.chart?.chartData
                }
            ];
        },
        reloadChartData() {
            return this.$store.state.chart.reloadChartData;
        },
        portfolioList() {
            return this.$store.state.investments.portfolioList;
        }
    },
    created() {
        this.requestChartData();
    },
    methods: {
        handleAddPortfolio() {
            this.$router.push("/new-workflow");
        },
        languageChange(languageId) {
            this.$store.commit("preference/SET_LANGUAGE_ID", languageId);
        },
        requestChartData() {
            this.chartLoading = true;
            let isValidBmk = false;
            this.$fetch({
                url: `/api/v1/Chart`,
                method: "POST",
                body: JSON.stringify(this.$store.getters["hypoInput"])
            })
                .then(data => {
                    if (this.$store.getters["chart/validBenchmarkData"](data.growth)) {
                        this.alertMessage = "";
                        this.invalidHoldings = [];
                        this.$store.commit(`chart/${types.SET_CHART_DATA}`, data);
                    } else {
                        isValidBmk = true;
                        this.getAlertInfo(data).then(() => {
                            const portfolio = data.growth.find(item => item.type === "Portfolio");
                            return this.changeBenchmarkByPortfolioId(portfolio.id);
                        });
                    }
                })
                .then(() => {
                    this.showAlert = isValidBmk;
                    this.$store.commit("chart/SET_RELOAD_CHART_DATA", false);
                    this.chartLoading = false;
                });
        },
        changeBenchmarkByPortfolioId(portfolioId) {
            // https://msjira.morningstar.com/browse/HYPO-1906
            // change benchmark to Standard Benchmark: S&P 500 TR USD - XIUSA04G92
            const benchmark = {
                includeBenchmark: true,
                benchmarkType: 0,
                benchmarkHoldings: [
                    {
                        securityId: "XIUSA04G92",
                        securityName: "S&P 500 TR USD(USD,XIUSA04G92)",
                        identifier: "XIUSA04G92"
                    }
                ],
                customBenchmarkId: "",
                customBenchmarkName: ""
            };
            const list = this.portfolioList.map(item => {
                if (item.id === portfolioId) {
                    return {
                        ...item,
                        benchmark: benchmark
                    };
                } else {
                    return item;
                }
            });
            this.$store.commit(`investments/${types.UPDATE_PORTFOLIOLIST}`, list);
            this.$store.commit(`investments/${types.UPDATE_RAW_PORTFOLIOLIST}`, list);
            return this.$store.dispatch("chart/getChartData", { fetch: this.$fetch });
        },
        getAlertInfo(data) {
            const portfolioData = data.growth.find(item => item.type === "Portfolio");
            const endDate = this.formatter.date(new Date(portfolioData.endDate), "dd-mm-yyyy");
            const portfolio = this.portfolioList[0];
            const benchmarkType = portfolio.benchmark.benchmarkType;
            const bmkTypeName = this.getUILabel(this.$store.getters["investments/benchmarkTypes"].find(item => item.id === benchmarkType).labelId);
            const alertMessage = `Your benchmark selection is switched to: S&P 500 TR USD.
                    Your former benchmark selection(${bmkTypeName}) could not be applied due to no price data available on ${endDate} for composite(s):`;

            if (benchmarkType === 1 || benchmarkType === 2) {
                //1: Auto Benchmark by Asset Allocation, 2: Auto Benchmark by Morningstar Category
                this.holdingsLoading = true;
                const assetGroups = this.$store.state.hypo.assetAllocation;
                return this.getAutoBenchmarkHoldings(benchmarkType, portfolio, assetGroups).then(data => {
                    this.alertMessage = alertMessage;
                    this.invalidHoldings = this.getInvalidHoldings(data);
                });
            } else if (benchmarkType === 3) {
                return this.getCustomBenchmarkHoldings(portfolio.benchmark.customBenchmarkId, {
                    startdate: portfolioData.startDate,
                    enddate: portfolioData.endDate
                }).then(data => {
                    this.alertMessage = alertMessage;
                    this.invalidHoldings = this.getInvalidHoldings(data);
                });
            } else {
                return Promise.reject("Incorrect benchmarkType (Not one of 1, 2, 3)");
            }
        },
        getInvalidHoldings(data) {
            return data
                .filter(item => !item.havePrice)
                .map(item => {
                    return {
                        id: item.securityId,
                        name: item.securityName
                    };
                });
        },
        getBenchmarkDataByPortfilio(portfolio, growthData) {
            const benchmarkData = growthData.find(i => i.type === "Benchmark" && i.id === portfolio.id);
            if (benchmarkData) {
                return {
                    name: benchmarkData.name
                };
            } else {
                return null;
            }
        },
        handleDeletePortfolio(portfolioId) {
            this.$store.dispatch("investments/deletePortfolio", portfolioId);
        },
        handleDuplicatePortfolio(portfolioId) {
            this.$store.dispatch("investments/duplicatePortfolio");
        },
        handleEditDetailedAssumptions(portfolioId) {
            this.$store.commit(`investments/${types.SET_EDITING_PORTFOLIO_ID}`, portfolioId);
            if (this.$store.getters["investments/editingPortfolio"]) {
                this.$router.push("/edit-assumptions");
            }
        },
        getAutoBenchmarkHoldings(benchmarkType, portfolio, assetGroups) {
            return this.$fetch({
                url: `/api/v1/benchmark/autobenchmark/${benchmarkType}`,
                method: "POST",
                body: JSON.stringify({
                    portfolio: portfolio,
                    assetGroups: assetGroups
                })
            });
        },
        getCustomBenchmarkHoldings(benchmarkId, params) {
            const searchParams = new URLSearchParams(params);
            return this.$fetch({
                url: `/api/v1/benchmark/custombenchmark/${benchmarkId}?${searchParams.toString()}`,
                method: "GET"
            });
        },
        handleScenarioModal() {
            this.showScenarioModal = false;
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .home__summary-header {
    .mds-section__header-container___hypo {
        margin: $mds-space-1-x 0;
    }
}

.home {
    padding-bottom: $mds-space-8-x;
    &--single {
        .home__portfolio-action-wrapper,
        .home-charts {
            margin-left: auto;
            margin-right: auto;
        }
    }

    &-placeholder-card {
        display: flex;
        justify-content: center;
        align-items: center;
        height: calc(100vh - 49px);
    }

    .js-is-sticky {
        box-shadow: $mds-box-shadow-drop;
    }

    .sticky-header {
        background-color: #fff;
        z-index: 1;
        width: 100%;
    }

    &__portfolio-action-wrapper {
        &:first-child {
            padding-left: $mds-space-2-x;
        }
        &:last-child {
            padding-right: $mds-space-2-x;
        }
    }

    &-chart-wrapper {
        position: relative;
        .mds-loader {
            position: absolute;
            top: 210px;
            left: 50%;
            transform: translateX(-50%);
            margin: 0px;
        }
    }

    &-alert {
        position: fixed;
        top: 20px;
        width: 600px;
        left: 30%;
        z-index: 12;
        ::v-deep .mds-alert__dismiss-button___hypo {
            height: 0px;
            top: 15px;
            right: 5%;
        }
    }

    &-error {
        position: fixed;
        top: 20px;
        width: 600px;
        left: 30%;
        z-index: 10;
        ::v-deep .mds-alert__dismiss-button___hypo {
            height: 0px;
            top: 15px;
            right: 5%;
        }
    }

    .time-label {
        color: #5e5e5e;
        font-size: 14px;
        line-height: 19px;
        font-weight: normal;
    }
}
</style>
